export default __webpack_public_path__ + "static/media/Roasting1.0c6a4c62.jpg";